<template>
  <div :class="isActive ? 'fullScreenContainer active' : 'fullScreenContainer'">
    <div class="popupContainer">
      <div class="topTextContainer">{{ popupText }}</div>
      <div class="bottomButtonsContainer">
        <div class="agreeButton" @click="agreeButtonClicked()">{{$t('I AGREE')}}</div>
        <div class="cancelButton" @click="cancelButtonClicked()">{{$t('CANCEL')}}</div>
      </div>
    </div>
  </div>
</template>
<script>
import "../scss/external-link-popup.css";

export default {
  props: {},
  methods: {
    agreeButtonClicked() {
      window.open(this.popupLink, "_blank").focus();
      this.isActive = false;
    },
    cancelButtonClicked() {
      this.$root.$emit('playVideo') 
      this.isActive = false;
    },
    resetPopupText() {
      this.popupText =
        this.$t("Leave Message");
    },
    showPopup(e) {
      this.$root.$emit('pauseVideo') 
      if (e.detail.alertText) {
        this.popupText = e.detail.alertText;
      }
      else{
          this.resetPopupText()
      }
      this.popupLink = e.detail.routeLink;
      this.isActive = true;
    }
  },
  mounted() {
    this.resetPopupText();
    window.addEventListener("openLink", this.showPopup);
  },
  data() {
    return {
      popupText: "",
      popupLink: "",
      isActive: false,
    };
  },
};
</script>
